<template>
  <BaseIndex
    ref="baseIndex"
   :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="saleOrders"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    :itemClass="itemClasses"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    :showSelected="showSelected"
    :changeSwitch="changeSwitch"
    @filter-confirm-action="applyFilters"
  >

    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

     <template slot="filterSwitch">
        <v-checkbox style="padding: 4px 16px;" label="Exibir apenas os pendentes" v-model="filterSwitch"></v-checkbox>
    </template>

    <template slot="filterText1">
        <v-card style="margin: 10px;">
          <v-text-field
            style="padding: 16px 16px;"
            v-model="clientName"
            label="Cliente"
            >
          </v-text-field>
        </v-card>
    </template>

    <template slot="new" v-if="saleOrderIds.length>0">
      <New
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :saleOrderIds="saleOrderIds"
        :inlineAddButton="false"
        newCreateButtonLabel="Criar Pedido"
        newSaveButtonLabel="Salvar"
        modelNameSingular="Multiplos Pedidos"
      />
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        v-if="item.statusKey == 'opened'"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :readOnly="item.statusKey != 'opened'"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    

    <!-- Gera a venda a partir do pedido -->
    <template slot="action1" slot-scope="{ item }" v-if="$can('create', 'Sale') && (item.statusKey == 'opened' || item.statusKey == 'awaiting_billing')">
      <SaleNew 
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :saleOrder="item"
        :inlineAddButton="true"
        newCreateButtonLabel="Gerar Venda deste Pedido"
        newSaveButtonLabel="Criar Venda do Pedido"
        modelNameSingular="Venda"
      />
    </template>

    <!-- fecha manualmente do pedido de venda -->
    <template slot="action2" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name) && (item.statusKey == 'opened' || item.statusKey == 'awaiting_billing')">
      <SaleOrderClose
        :entry="item"
        @entry-destroyed="entryClosed"
        @entry-canceled="loadServerEntries()"
      />
    </template>    

    <template slot="action3" slot-scope="{ item }" v-if="true">
      <DuplicateSaleOrder
        :entry="item"
        @entry-destroyed="entryClosed"
        @entry-canceled="loadServerEntries()"
      />
    </template>

    <template slot="action4" slot-scope="{ item }" v-if="item.status == 0 && loggedUser && loggedUser.account && loggedUser.account.hasSeedlingProducerBusinessActivity">
      <NewPlanningSeedPlotOperation
        :saleOrder="item"
        @entry-created="entryCreated"
        :inlineAddButton="false"
        @entry-canceled="loadServerEntries()"
        newCreateButtonLabel="Gerar planejamentos de semeio"
        newSaveButtonLabel="Salvar"
        modelNameSingular="Planejamento de Semeio"
      />
    </template>

    <template  slot="action5" slot-scope="{ item }">
      <BasePdfViewer
        :pdfSource="item.pdf"
        :pdfNumPages="numPages"
        :loading="false"
        :pdfTitle="'Pedido-' + item.code"
        @pdf-open-action="getNfePdf(item, function() {return null;})"
        ref="nfePdfRef"
      />
    </template>

    <!-- <template slot="action3" slot-scope="{ item }" v-if="$can('create', $router.currentRoute.name) && (item.statusKey == 'opened')">
      <Merge
        :entry="item"
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template> -->

    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="3" class="text-right"><strong class="title mx-3">Total: </strong></td>
        <td colspan="2" class="text-left title"><strong>{{ this.totalValue | formatCurrency }}</strong></td>
      </tr>
      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total: </div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.totalValue | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
// import Merge from "./merge.vue";
import SaleOrderClose from "./close.vue";
import SaleNew from "@models/sales/new.vue";
import DuplicateSaleOrder from "./duplicate.vue";
import BasePdfViewer from "@shared_components/base_pdf_viewer.vue";
// import NewPlanningSeedPlotOperation from "@models/operations/planning_seed_plot_operations/new.vue";
import NewPlanningSeedPlotOperation from "./new_planning_seed_plot_operation.vue";


export default {
  data() {
    return {
      saleOrders: [],
      saleOrderIds: [],
      loading: true,
      loggedUser: null,
      totalValue: 0,
      numPages: 1,
      pageLoading: false,
      filterSwitch: true,
      clientName: null,
      timer: null,
      firstCustomerId: 0,
      totalItems: 0,
      tableHeaders: [
        { text: "Nº Pedido", align: "left", sortable: true, value: "code"},
        { text: "Cliente", align: "left", sortable: true, value: "clientName"},
        { text: "Rotas", align: "left", sortable: true, value: "routes"},
        { text: "Valor", align: "left", sortable: false, value: "totalPrice"},
        { text: "Data", align: "left", sortable: true, value: "date" },
        { text: "Hora", align: "left", sortable: false, value: "saleOrderTime" },
        // { text: "Recebido", align: "left", sortable: false, value: "totalPaidAmount"},
        // { text: "Pendente", align: "left", sortable: false, value: "unpaidAmount"},
        { text: "Estimativa de Entrega", align: "left", sortable: true, value: "estimatedDeliveryDate" },
        // { text: "Entrega", align: "left", sortable: true, value: "deliveryDate" },
        // { text: "Faturamento", align: "left", sortable: true, value: "billDate" },
        // { text: "Doc. Fiscal", align: "left", sortable: true, value: "fiscalDocumentType" },
        { text: "CFOP", align: "left", sortable: true, value: "cfopCode" },
        { text: "Status", align: "left", sortable: true, value: "saleStatus" },
        // { text: "NF-e", align: "left", sortable: false, value: "link" },
        { text: "Selecionado", align: "left", sortable: false, value: "selected"},
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'billDate', mask: 'date' }, 
        { field: 'date', mask: 'date' }, 
        { field: 'deliveryDate', mask: 'date' },        
        { field: 'estimatedDeliveryDate', mask: 'date' },
        { field: 'totalPrice', mask: 'currency' }, 
        { field: 'totalPaidAmount', mask: 'currency' }, 
        { field: 'unpaidAmount', mask: 'currency' }, 
        { field: 'saleStatus', mask: 'status_color', colorField: 'statusColor' }, 
      ],
      infoHeaders: [
        { field: 'totalPrice', info: 'Valor da venda a receber (capital)' },
        { field: 'totalPaidAmount', info: 'Valor já recebido da venda incluindo juros, multas e descontos' },
        { field: 'unpaidAmount', info: 'Valor restante a ser recebido (capital)' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: [],
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Pedido de Venda"
    },
    modelNamePlural: {
      type: String,
      default: "Pedidos de Vendas"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    // Merge: Merge,
    SaleNew: SaleNew,
    SaleOrderClose: SaleOrderClose,
    DuplicateSaleOrder: DuplicateSaleOrder,
    NewPlanningSeedPlotOperation: NewPlanningSeedPlotOperation,
    BasePdfViewer: BasePdfViewer,
  },
  created() {
    this.getCurrentUser(user => {
      this.loggedUser = user;
    });
    // this.loadServerEntries();
    // let data = this.$root.$data
    // this.getCurrentUser(user => {
    //   console.log("feito", user);
    // });
    // setTimeout(function(){
    //   console.log("Index sale", data.localUser);
    // }, 1000)
  },
  mounted() { 
    
  },
  watch: {
    "filterSwitch": function(item){
      // console.log(item);
      this.loadServerEntries();
    },
    "clientName": function(newSearch) {
      if (this.clientName && this.clientName.length > 0) {
        if (newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log("newSearch", newSearch); 
            this.loadServerEntries();
          }, 2000);
        }
      }else{
        if(this.timer){
          clearTimeout(this.timer);
        }
        this.loadServerEntries();
      }
    },
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_SALE_ORDERS,
          variables: {
            input: {
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.value),
              filters: this.filters,
              customFilters: {not_invoiced: this.filterSwitch, client_name: this.clientName},
            },
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("response", response); 
          this.saleOrders = response.data.accountContext.saleOrdersIndex.saleOrderViewIndexFilters;
          
          this.totalValue = response.data.accountContext.saleOrdersIndex.totalValue;
          this.totalItems = response.data.accountContext.saleOrdersIndex.count;
          this.typeOperators = response.data.accountContext.saleOrdersIndex.typeOperators;
          this.serverFields = response.data.accountContext.saleOrdersIndex.serverFields;
          // console.log("All saleOrdersIndex", this.saleOrders, this.totalItems);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    entryClosed: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("Pedido de venda fechado com sucesso!");
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
    itemClasses: function(item) {
      // if (item.statusKey == "opened") {
      //   return "opened_item";
      // } else if (item.unpaidAmount > 0) {
      //   return "pending_item";
      // }
    },
    changeSwitch(item){
      if (item.selected == false){
        this.saleOrderIds = this.saleOrderIds.filter(function(id){
          return id !== item.id;
        });
      }else{
        this.saleOrderIds.push(item.id);
        if(this.saleOrderIds.length == 1){
          this.firstCustomerId = item.clientName;
        }
      }
      // console.log(this.saleItemLots);
    },
    showSelected: function (item) {
      // console.log('item', item);
      if (item.__typename == "SaleOrder" && item.status == 1) {
        // console.log("aquiii");
        return true;
      }else if(item.__typename == "SaleOrder" && item.status == 0){
        if(this.saleOrderIds && this.saleOrderIds.length>0){
          // console.log("hh",item.clientName, this.firstCustomerId);
          if(item.clientName == this.firstCustomerId){
            // console.log("false");
            return false;
          }
          // console.log("true");
          return true;
        }else{
          return false;
        }
      }
      else if (item.__typename == "Nfe" && (item.statusKey != "authorized" || item.hasMdfe)) {
        return true
      }
      else {
        return false;
      }
    },

    getNfePdf: function(saleOrder, callback) {
      if (saleOrder.pdf) {
        callback(saleOrder.pdf);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_PDF_MUTATION,
          variables: {
            id: saleOrder.id
          },
        })
        .then(response => {
          var response_data="";
          response_data = response.data.downloadPdf;
          var errors = response_data
          // console.log(errors)
          if (errors.length > 0){
            this.indexErrors = errors;
            this.$refs.nfePdfRef.closeDialog();
          } else {
            let pdfFile = "data:application/octet-stream;base64," + response_data.pdf
            // console.log("resp "+response_data.numPages);
            this.numPages = response_data.numPages;
            this.$set(saleOrder, 'pdf', pdfFile);
            callback(pdfFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
  }
}; 

const LOAD_ALL_SALE_ORDERS = gql `
  query($input: IndexInputObject!) {
    accountContext {
      saleOrdersIndex(input: $input) {
        count
        totalValue
        saleOrderViewIndexFilters {
          id
          code
          cfopCode
          status
          date
          saleOrderTime
          statusKey
          saleStatus
          statusColor
          clientName
          routes
          estimatedDeliveryDate
          totalPrice
          canBeDeleted
          undeletabilityReasons
          netWeight
          grossWeight
          selected
        }
        typeOperators
        serverFields
      }
    }
  }
`;

const DOWNLOAD_PDF_MUTATION = gql `
  mutation($id: ID!){
    downloadPdf(id: $id) {
      pdf
      errors
      numPages
    }
  }
`;

</script>

<style scoped>
  ::v-deep .pending_item {
    color: blue;
  }

  ::v-deep .opened_item {
    color: rgb(134, 134, 134);
    font-style: italic;
  }
</style>
